import { useState } from 'react';

export enum Section {
  CommitmentOverview = 'commitment-overview',
  FundPerformance = 'fund-performance',
  LiveHoldings = 'live-holdings',
  RealisedHoldings = 'realised-holdings',
  CapitalHistory = 'capital-history',
  PreferredReturnBalance = 'preferred-return-balance',
  FundCloseHistory = 'fund-close-history',
  FeesAndCharges = 'fees-and-charges',
  IncomesAndExpenses = 'incomes-and-expenses',
  Pcap = 'pcap',
  CapitalBalanceAndReconciledPayments = 'capital-balance-and-reconciled-payments',
}

type SectionData = {
  id: Section;
  label: string;
  customTitle?: string;
};

const sectionConfig: Array<SectionData> = [
  {
    id: Section.CommitmentOverview,
    label: 'Commitment',
    customTitle: 'Overview',
  },
  { id: Section.FundPerformance, label: 'Overall fund performance' },
  { id: Section.LiveHoldings, label: 'Live portfolio holdings' },
  { id: Section.RealisedHoldings, label: 'Realised portfolio holdings' },
  { id: Section.CapitalHistory, label: 'Capital history' },
  { id: Section.PreferredReturnBalance, label: 'Preferred return balance' },
  { id: Section.FundCloseHistory, label: 'Fund close history' },
  { id: Section.FeesAndCharges, label: 'Fees and charges' },
  { id: Section.IncomesAndExpenses, label: 'Incomes and expenses' },
  {
    id: Section.CapitalBalanceAndReconciledPayments,
    label: 'Capital balance and reconciled payments',
  },
  {
    id: Section.Pcap,
    label: 'PCAP',
  },
];

type SectionState = Array<SectionData & { isExpanded: boolean }>;

export const useCommitmentViewSections = () => {
  const [sections, setSections] = useState<SectionState>(
    sectionConfig.map((section) => ({ ...section, isExpanded: true })),
  );

  const toggleSection = (id: string) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === id
          ? { ...section, isExpanded: !section.isExpanded }
          : section,
      ),
    );
  };

  return {
    sections,
    toggleSection,
  };
};
